import { DISCOUNTS } from '../constants';
import { DISCOUNTED_RATIO, FOUNDERS_DISCOUNT } from '../constants/DISCOUNTS';

/**
 * Item Final Cost
 * @param {object} item
 * @param {number} itemPrivateSale
 * @param {number} cohort 1, 2, 3
 * @param {object} lowestPriceItem // For CA EVENT Logic
 * @returns {number}
 */
export const itemFinalCost = (
  item,
  itemPrivateSale,
  cohort,
  lowestPriceItem,
) => {
  const isBundle = item.parentAreaId === 'bundles';
  const isFullBody = item.id === 'full_body';

  let discount = DISCOUNTS[item.discount];

  //   ---- NEW - 2025 Bundles Discount Logic ---- //
  // Apply the new 2025 discounted ratio. Each bundle has a different discount ratio.
  // if (isBundle && !isFullBody) { // Original Logic
  // New Logic: Dec 2025 - Treat Full Body the same as other bundles
  if (isBundle) {
    if (item.discount === 'BNDLE') {
      discount = DISCOUNTED_RATIO[item.id];
    } else if (item.discount === 'Military') {
      // The military discount is 10% of the Bundle Discounted Price
      // OR 55% off for Full Body
      discount = isFullBody ? 0.55 : 0.1 + 0.9 * DISCOUNTED_RATIO[item.id];
    } else if (item.discount === 'Founders') {
      discount = FOUNDERS_DISCOUNT[item.id];
    }
  }

  // -------------- CA EVENT OR FOUNDERS - NEW Logic -------------- //
  const EVENT_DISCOUNT = 'CA EVENT - NEW'; // OR 'FOUNDERS - NEW'
  // If the item is the lowest price item and the discount is 'CA EVENT - NEW'. Apply 50% discount
  const is50Discount =
    item.discount === EVENT_DISCOUNT && item.id === lowestPriceItem?.id;
  if (is50Discount) {
    discount = 0.5;
  }
  // ------------------------------------------------//

  return +(
    (item.prices[`cohort_${cohort}`] - itemPrivateSale) *
    (1 - discount)
  ).toFixed(2);
};
